import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import scale from "../assets/images/scale.webp";
import syllabusData from '../data/syllabusTree.json';
import '../styles/AllNotes.css';

const AllNotes = () => {
  const [activeCourse, setActiveCourse] = useState("3YDC");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <div className="allnotes-page">
      <Helmet>
        <title>All Notes Syllabus | TejCodex</title>
        <meta name="description" content="A complete hierarchical flowchart of all law notes for 3YDC and 5YDC provided by TejCodex." />
        <link rel="canonical" href="https://tejcodex.com/all-notes" />
      </Helmet>

      <Navbar />

      <main className="allnotes-container">
        <header className="allnotes-header">
          <img src={scale} alt="Scale of Justice" className="allnotes-scale-icon" />
          <h1 className="allnotes-title">Index of Legal Notes</h1>
          <p className="allnotes-subtitle">Osmania University Syllabus Archive</p>
          <hr className="allnotes-divider" />
        </header>

        <section className="notes-modern">
          {/* COURSE TABS */}
          <div className="course-tabs">
            {["3YDC", "BALLB", "BBALLB", "BCOMLLB"].map((course) => (
              <button
                key={course}
                className={`tab-btn ${activeCourse === course ? "active" : ""}`}
                onClick={() => setActiveCourse(course)}
              >
                {course}
              </button>
            ))}
          </div>

          {/* CONTENT */}
          <div className="course-content">
            {activeCourse === "3YDC" && (
              Object.keys(syllabusData["3YDC"]).map((sem) => (
                <div className="semester-block" key={sem}>
                  <details>
                    <summary>Semester {sem}</summary>

                    <div className="subject-grid">
                      {syllabusData["3YDC"][sem].map((sub, i) => (
                        <a key={i} href={sub.url} className="subject-card">
                          {sub.name}
                        </a>
                      ))}
                    </div>
                  </details>
                </div>
              ))
            )}

            {activeCourse !== "3YDC" && (
              Object.keys(syllabusData["5YDC"][activeCourse]).map((sem) => (
                <div className="semester-block" key={sem}>
                  <details>
                    <summary>Semester {sem}</summary>

                    <div className="subject-grid">
                      {syllabusData["5YDC"][activeCourse][sem].map((sub, i) => (
                        <a key={i} href={sub.url} className="subject-card">
                          {sub.name}
                        </a>
                      ))}
                    </div>
                  </details>
                </div>
              ))
            )}
          </div>
        </section>
      </main>

      <footer className="Hfooter-section">
        <div className="Hfooter-top">
          <img src={scale} alt="Scale" className="Hfooter-logo" />
          <span className="Hfooter-title">TejCodex.com</span>
          <span className="Hfooter-rights">© 2025 All rights reserved.</span>
        </div>

        <div className="Hfooter-links" style={{ paddingBottom: "20px" }}>
          <a href="/">Home</a> |<a href="/notes"> Notes</a> |
          <a href="/pyqs"> PYQs</a> |<a href="/aibe-preparation"> AIBE</a> |<a href="/all-notes"> Index of All Notes</a> |
          <a href="/about"> About Us</a> |
          <a href="/contact"> Contact Us</a>
        </div>
      </footer>
    </div>
  );
};

export default AllNotes;
